<template>
  <div class="center-container">
    <h3>
      <img class="logo" src="@/assets/logo.jpg" alt="" />
      报名表填写
    </h3>
    <mu-form
      ref="form"
      :model="form"
      class="mu-form"
      :label-position="labelPosition"
      label-width="135"
    >
      <div class="box">
        <mu-form-item label="招生老师">
          <mu-text-field v-model="teacher_name" disabled></mu-text-field>
        </mu-form-item>
        <!-- <mu-form-item prop="form_subject" :rules="defaultRules">
          <div slot="label">
            <label class="label-required">培训科目</label>
          </div>
          <mu-select v-model="form.form_subject">
            <mu-option
              v-for="(option, index) in options"
              :key="index"
              :label="option.name"
              :value="option.value"
            ></mu-option>
          </mu-select>
        </mu-form-item> -->
        <mu-form-item>
          <div slot="label">
            <label class="label-required">培训科目</label>
          </div>
          <mu-text-field
            v-model="selectedValues"
            @click="show = true"
          ></mu-text-field>
          <van-popup v-model="show" round position="bottom">
            <van-cascader
              title="请选择分类"
              :options="cascaderOptions"
              @finish="onCascaderFinish"
              @close="show = false"
            />
          </van-popup>
        </mu-form-item>
      </div>
      <div class="box">
        <div class="person-info-box">
          <div class="idCard">
            <div class="label">
              <span style="color: red">*</span>
              电子证件照：
            </div>
            <van-uploader
              v-model="imageList"
              class="idCard-upload"
              upload-text="点击上传"
              :max-count="1"
              :after-read="imgUpload"
            />
          </div>
          <div class="info-box">
            <mu-form-item prop="name" label-width="74" :rules="defaultRules">
              <div slot="label">
                <label class="label-required">姓名</label>
              </div>
              <mu-text-field v-model="form.name"></mu-text-field>
            </mu-form-item>
            <mu-form-item prop="gender" label-width="74" :rules="defaultRules">
              <div slot="label">
                <label class="label-required">性别</label>
              </div>
              <mu-select v-model="form.gender">
                <mu-option
                  v-for="(option, index) in gender_options"
                  :key="index"
                  :label="option.name"
                  :value="option.id"
                ></mu-option>
              </mu-select>
            </mu-form-item>
            <mu-form-item prop="mobile" label-width="74" :rules="mobileRules">
              <div slot="label">
                <label class="label-required">手机号</label>
              </div>
              <mu-text-field v-model="form.mobile"></mu-text-field>
            </mu-form-item>
            <mu-form-item prop="diploma" label-width="74" :rules="defaultRules">
              <div slot="label">
                <label class="label-required">学历</label>
              </div>
              <mu-select v-model="form.diploma">
                <mu-option
                  v-for="(option, index) in diploma_options"
                  :key="index"
                  :label="option.name"
                  :value="option.name"
                ></mu-option>
              </mu-select>
            </mu-form-item>
          </div>
        </div>
        <mu-form-item prop="idcard" :rules="idcardRules">
          <div slot="label">
            <label class="label-required">身份证号</label>
          </div>
          <mu-text-field v-model="form.idcard"></mu-text-field>
        </mu-form-item>
        <mu-form-item prop="address" :rules="defaultRules">
          <div slot="label">
            <label class="label-required">现居住地</label>
          </div>
          <mu-text-field
            v-model="form.address"
            multi-line
            :rows="1"
            :rows-max="2"
          ></mu-text-field>
        </mu-form-item>
        <!-- <mu-form-item prop="political_affiliation" :rules="defaultRules">
          <div slot="label">
            <label class="label-required">政治面貌</label>
          </div>
          <mu-select v-model="form.political_affiliation">
            <mu-option
              v-for="(option, index) in political_options"
              :key="index"
              :label="option.name"
              :value="option.name"
            ></mu-option>
          </mu-select>
        </mu-form-item> -->
        <!-- <mu-form-item label="户籍所在地" prop="registered_residence">
          <mu-text-field v-model="form.registered_residence"></mu-text-field>
        </mu-form-item> -->
        <!-- <mu-form-item label="项目/工号" prop="work_no">
          <mu-text-field v-model="form.work_no"></mu-text-field>
        </mu-form-item> -->
      </div>
      <div class="box">
        <!-- <mu-form-item label="所学专业" prop="major">
          <mu-text-field v-model="form.major"></mu-text-field>
        </mu-form-item> -->
        <!-- <mu-form-item prop="graduation_school" :rules="defaultRules">
          <div slot="label">
            <label class="label-required">毕业学校</label>
          </div>
          <mu-text-field v-model="form.graduation_school"></mu-text-field>
        </mu-form-item> -->
        <mu-form-item prop="company" :rules="defaultRules">
          <div slot="label">
            <label class="label-required">现工作单位全称</label>
          </div>
          <mu-text-field v-model="form.company"></mu-text-field>
        </mu-form-item>
        <mu-form-item label="工号" prop="work_no">
          <mu-text-field v-model="form.work_no"></mu-text-field>
        </mu-form-item>
        <mu-form-item label="部门/中心" prop="department">
          <mu-text-field v-model="form.department"></mu-text-field>
        </mu-form-item>
        <mu-form-item label="岗位" prop="post">
          <mu-text-field v-model="form.post"></mu-text-field>
        </mu-form-item>
        <!-- <mu-form-item prop="cert_company" :rules="defaultRules">
          <div slot="label">
            <label class="label-required">(结业证)出证单位</label>
          </div>
          <mu-text-field v-model="form.cert_company"></mu-text-field>
        </mu-form-item> -->
        <!-- <mu-form-item prop="work_date" :rules="defaultRules">
          <div slot="label">
            <label class="label-required">参加工作时间</label>
          </div>
          <mu-date-input
            v-model="form.work_date"
            value-format="YYYY-MM-DD"
            type="date"
            container="bottomSheet"
          ></mu-date-input>
        </mu-form-item> -->
        <!-- <mu-form-item prop="mail_address" :rules="defaultRules">
          <div slot="label">
            <label class="label-required">寄件地址</label>
          </div>
          <mu-text-field
            v-model="form.mail_address"
            multi-line
            :rows="1"
            :rows-max="2"
          ></mu-text-field>
        </mu-form-item> -->
      </div>
      <div class="box">
        <mu-form-item prop="invoice_type" label="开票类型">
          <mu-select v-model="form.invoice_type">
            <mu-option
              v-for="(option, index) in invoice_type_options"
              :key="index"
              :label="option.name"
              :value="option.value"
            ></mu-option>
          </mu-select>
        </mu-form-item>
        <mu-form-item prop="invoice_company" label="开票单位">
          <mu-text-field
            v-model="form.invoice_company"
            multi-line
            :rows="1"
            :rows-max="2"
          ></mu-text-field>
        </mu-form-item>
        <mu-form-item prop="invoice_tax_id" label="税号">
          <mu-text-field v-model="form.invoice_tax_id"></mu-text-field>
        </mu-form-item>
        <mu-form-item prop="invoice_address" label="地址、电话">
          <mu-text-field
            v-model="form.invoice_address"
            multi-line
            :rows="1"
            :rows-max="2"
          ></mu-text-field>
        </mu-form-item>
        <mu-form-item prop="invoice_account" label="开户行及账号">
          <mu-text-field
            v-model="form.invoice_account"
            multi-line
            :rows="1"
            :rows-max="2"
          ></mu-text-field>
        </mu-form-item>
      </div>
      <div class="box">
        <div>照片</div>
        <div class="upload-box upload-box-top">
          <div class="upload-item">
            <div class="label">身份证人像面:</div>
            <van-uploader
              v-model="idcard_front"
              class="upload-t"
              upload-text="点击上传"
              :max-count="1"
              :after-read="imgUploadFront"
            />
          </div>
          <div class="upload-item">
            <div class="label">身份证国徽面:</div>
            <van-uploader
              v-model="idcard_back"
              class="upload-t"
              upload-text="点击上传"
              :max-count="1"
              :after-read="imgUploadBack"
            />
          </div>
        </div>
        <div class="upload-box upload-box-bottom">
          <div class="upload-item">
            <div class="label">学历:</div>
            <van-uploader
              v-model="diploma_img"
              class="upload-t"
              upload-text="点击上传"
              :max-count="1"
              :after-read="imgUploadDiploma"
            />
          </div>
          <div class="upload-item">
            <div class="label">承诺书:</div>
            <van-uploader
              v-model="work_img"
              class="upload-t"
              upload-text="点击上传"
              :max-count="1"
              :after-read="imgUploadWork"
            />
          </div>
        </div>
      </div>
      <div class="box">
        <mu-form-item label="其他附件">
          <fileUpload
            ref="upload"
            :max="8"
            :max-size="20000"
            @uploaded="uploaded"
          ></fileUpload>
        </mu-form-item>
        <div class="file-list">
          <div
            v-for="(file, index) in fileList"
            :key="index"
            class="file-list-item"
          >
            <mu-icon size="20" value="attach_file" color="#aaa"></mu-icon>
            <div class="name">{{ file.name }}</div>
            <mu-icon
              size="20"
              value="cancel"
              color="#aaa"
              @click="deleteFile($event, index)"
            ></mu-icon>
          </div>
        </div>
      </div>
      <div class="footer">
        <mu-button color="primary" @click="submit">提交</mu-button>
        <!-- <mu-button @click="clear">重置</mu-button> -->
      </div>
    </mu-form>
  </div>
</template>

<script>
import { TeacherDetail, SignupSave, fetchSignupSubjects } from '@/api/index'
import fileUpload from '@/components/Upload'
import { Uploader } from 'vant'
import { useApi } from '@/hooks/useApi'
import { Cascader, Popup } from 'vant'
// import dayjs from 'dayjs'
export default {
  name: 'Registration',
  components: {
    fileUpload,
    'van-uploader': Uploader,
    'van-cascader': Cascader,
    'van-popup': Popup,
  },
  data() {
    return {
      teacher_id: null,
      teacher_name: null,
      options: [
        {
          name: '消防安全责任人（法人）',
          value: 's0',
        },
        {
          name: '消防安全管理人',
          value: 's1',
        },
        {
          name: '五级/初级消防设施操作员',
          value: 's2',
        },
        {
          name: '四级/中级消防设施操作员（监控）',
          value: 's3',
        },
        {
          name: '四级/中级消防设施操作员（检测维保）',
          value: 's4',
        },
      ],
      political_options: [
        {
          name: '中国共产党党员',
        },
        {
          name: '民主党派人士',
        },
        {
          name: '群众',
        },
      ],
      gender_options: [
        {
          name: '男',
          id: 1,
        },
        {
          name: '女',
          id: 2,
        },
      ],
      invoice_type_options: [
        {
          name: '普票',
          value: 1,
        },
        {
          name: '专票',
          value: 2,
        },
        {
          name: '个人',
          value: 3,
        },
      ],
      diploma_options: [
        {
          name: '硕士',
        },
        {
          name: '本科',
        },
        {
          name: '大专',
        },
        {
          name: '高中',
        },
        {
          name: '职高',
        },
        {
          name: '中专',
        },
      ],
      labelPosition: 'left',
      defaultRules: [{ validate: (val) => !!val, message: '未填写必填项' }],
      mobileRules: [
        { validate: (val) => !!val, message: '未填写必填项' },
        {
          validate: (val) => {
            var str = /^[1][3-9][0-9]{9}$/
            return str.test(val)
          },
          message: '手机号格式不正确',
        },
      ],
      idcardRules: [
        { validate: (val) => !!val, message: '未填写必填项' },
        {
          validate: (val) => {
            return this.checkCode(val)
          },
          message: '身份证号格式不正确',
        },
      ],
      showPicker: false,
      form: {},
      fileList: [],
      imageList: [],
      uploadType: 'idcard_front',
      idcard_front: [], // 身份证正面照
      idcard_back: [], // 身份证反面照
      diploma_img: [], // 学历照
      work_img: [], // 承诺书
      show: false,
      selectedValues: '',
      cascaderOptions: [
        {
          text: '课程分类',
          value: 'course',
          children: [
            {
              text: '前端开发',
              value: 'frontend',
              children: [
                { text: 'Vue.js', value: 'vue' },
                { text: 'React', value: 'react' },
              ],
            },
            {
              text: '后端开发',
              value: 'backend',
              children: [
                { text: 'Node.js', value: 'node' },
                { text: 'Java', value: 'java' },
              ],
            },
          ],
        },
        {
          text: '考试分类',
          value: 'exam',
          children: [{ text: '模拟考试', value: 'mock' }],
        },
      ],
    }
  },
  created() {
    this.teacher_id = this.$route.query.teacher_id
    this.getTeacher()
    this.getSubject()
  },
  methods: {
    onCascaderFinish({ selectedOptions, value }) {
      this.selectedValues = selectedOptions
        .map((option) => option.text)
        .join('/')
      this.form.form_subject = value
      console.log('value', value)

      this.show = false
    },
    // 获取招生老师
    getTeacher() {
      if (!this.teacher_id) {
        this.$confirm('未带有教师编号！', '提示')
        return
      }
      TeacherDetail({
        teacher_id: this.teacher_id,
      })
        .then((res) => {
          this.teacher_name = res.teacher_name
        })
        .catch(() => {
          this.teacher_name = ''
        })
    },
    // 获取培训科目列表
    async getSubject() {
      try {
        const res = await fetchSignupSubjects()
        console.log('=======', res)
        // this.options = res.subject_list.map((item) => {
        //   return {
        //     name: item.text,
        //     value: item.value,
        //   }
        // })
        this.cascaderOptions = this.renameFields(res.subject_list)
      } catch (error) {
        console.log('ERROR', error)
      }
    },
    renameFields(data) {
      return data.map((item) => {
        const newItem = {
          text: item.name, // name -> text
          value: item.id, // 保留原始ID
          ...(item.pid && { pid: item.pid }), // 可选：保留pid字段
        }

        // 递归处理子项 (child -> children)
        if (item.child && item.child.length > 0) {
          newItem.children = this.renameFields(item.child)
        }

        return newItem
      })
    },
    // 父子组件文件列表统一
    uploaded(files) {
      this.fileList = files
    },
    imgUpload(file) {
      // console.log(file);
      file.status = 'uploading'
      file.message = '上传中...'
      useApi(
        {
          url: '/v1/api/upload',
        },
        {
          files: [file.file],
        }
      )
        .then(({ data }) => {
          file.status = 'done'
          this.imageList[0].id = data.info.id
          // console.log(this.imageList);
          this.$emit('uploaded', this.imageList)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    imgUploadFront(file) {
      this.imgUploadFunc(file, 'idcard_front')
    },
    imgUploadBack(file) {
      this.imgUploadFunc(file, 'idcard_back')
    },
    imgUploadDiploma(file) {
      this.imgUploadFunc(file, 'diploma_img')
    },
    imgUploadWork(file) {
      this.imgUploadFunc(file, 'work_img')
    },
    imgUploadFunc(file, type) {
      file.status = 'uploading'
      file.message = '上传中...'
      useApi(
        {
          url: '/v1/api/upload',
        },
        {
          files: [file.file],
        }
      )
        .then(({ data }) => {
          file.status = 'done'
          this[type][0].id = data.info.id
          // console.log(this.imageList);
          this.$emit('uploaded', this[type])
        })
        .catch((error) => {
          console.log(error)
        })
    },
    // 删除文件
    deleteFile(e, index) {
      e.preventDefault()
      this.$refs.upload.deleteFile(index)
    },
    // 删除文件
    deleteImage(index) {
      this.$refs.imgUpload.deleteFile(index)
    },
    submit() {
      if (this.imageList.length == 0) {
        this.$confirm('请上传电子证件照！', '提示')
        return
      }
      this.$refs.form.validate().then((validate) => {
        if (validate) {
          this.$confirm('确定提交吗？', '提示').then(({ result }) => {
            if (result) {
              this.form.teacher_id = this.teacher_id
              const fileIdArr = []
              for (let file of this.fileList) {
                fileIdArr.push(file.id)
              }
              this.form.files = fileIdArr.join(',')
              this.form.photo = this.imageList.map((item) => {
                return item.id
              })
              this.form.photo = this.form.photo.join(',')
              this.form.idcard_front = this.idcard_front.map((item) => {
                return item.id
              })
              this.form.idcard_front = this.form.idcard_front.join(',')
              this.form.idcard_back = this.idcard_back.map((item) => {
                return item.id
              })
              this.form.idcard_back = this.form.idcard_back.join(',')
              this.form.diploma_img = this.diploma_img.map((item) => {
                return item.id
              })
              this.form.diploma_img = this.form.diploma_img.join(',')
              this.form.work_img = this.work_img.map((item) => {
                return item.id
              })
              this.form.work_img = this.form.work_img.join(',')
              SignupSave(this.form).then((res) => {
                if (res) {
                  this.$alert('提交成功！', '提示')
                  this.clear()
                }
              })
            }
          })
        } else {
          this.$confirm('有必填项未填写！', '提示')
        }
      })
    },
    // 清空
    clear() {
      this.form = {}
      this.$refs.upload.clear()
    },
    // 验证身份证
    checkCode(val) {
      if (val.length > 15) {
        const p =
          /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
        const factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
        const parity = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
        const code = val.substring(17)
        if (p.test(val)) {
          let sum = 0
          for (let i = 0; i < 17; i++) {
            sum += val[i] * factor[i]
          }
          if (parity[sum % 11] == code.toUpperCase()) {
            this.getSex(val.charAt(16))
            return true
          }
        }
        return false
      } else {
        return /(^\d{8}(0\d|10|11|12)([0-2]\d|30|31)\d{3}$)|(^\d{6}(18|19|20)\d{2}(0\d|10|11|12)([0-2]\d|30|31)\d{3}(\d|X|x)$)/.test(
          val
        )
      }
    },
    getSex(data) {
      let sex = ''
      if (parseInt(data) % 2 == 0) {
        sex = '女'
      } else {
        sex = '男'
      }
      this.$set(this.form, 'gender', sex)
    },
  },
}
</script>

<style lang="scss" scoped>
.center-container {
  min-height: 100%;
  width: 100vw;
  // display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.54);
  background: #efefef;
  padding: 0 0 12px 0;
}
h3 {
  margin: 0;
  font-size: 24px;
  color: rgba(0, 0, 0, 1);
  padding: 12px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  .logo {
    width: 80px;
    height: 36px;
    margin: 0 16px 0 -80px;
  }
}
.mu-form {
  width: 100%;
  padding: 0 12px;
  .box {
    width: 100%;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 0 8px 0 #ccc;
    padding: 12px;
    margin-bottom: 12px;
    .person-info-box {
      width: 100%;
      display: flex;
      .idCard {
        width: 34%;
        max-width: 130px;
        display: flex;
        flex-direction: column;
        margin-right: 6%;
        .label {
          font-size: 14px;
          margin-top: 14px;
          margin-bottom: 4px;
        }
        .idCard-upload {
          flex: 1;
          width: 100%;
          overflow: hidden;
          /deep/ .van-uploader__wrapper {
            width: 100%;
            height: 100%;
            .van-uploader__upload {
              width: 100%;
              height: 100%;
              margin: 0;
            }
            .van-uploader__preview {
              width: 100%;
              height: 100%;
              margin: 0;
              .van-uploader__preview-image {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
      .info-box {
        flex: 1;
      }
    }
    .label-required::before {
      content: '*';
      color: red;
      margin-right: 4px;
    }
    .mu-form-item {
      padding: 4px 0 0 0;
      margin: 0;
    }
    // /deep/.mu-text-field-input {
    //   text-align: end;
    // }
    &:last-child {
      margin: 0;
    }
    /deep/.mu-form-item-content {
      display: flex;
      justify-content: flex-end;
    }
    /deep/.mu-text-field-input,
    /deep/.mu-select-input {
      text-align: end;
    }

    .file-list {
      font-size: 14px;
      padding: 4px 8px;

      .file-list-item {
        display: flex;
        align-items: center;

        .name {
          flex: 1;
          display: block;
          // width: 200px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
        .icon {
        }
      }
    }

    .upload-box {
      width: 100%;
      display: flex;
      .upload-item {
        flex: 1;
        height: 100%;
        margin-right: 12px;
        display: flex;
        flex-direction: column;
        &:last-child {
          margin: 0;
        }
        .label {
          font-size: 14px;
          margin-top: 8px;
          margin-bottom: 4px;
        }
        .upload-t {
          flex: 1;
          width: 100%;
          overflow: hidden;
          /deep/ .van-uploader__wrapper {
            width: 100%;
            height: 100%;
            .van-uploader__upload {
              width: 100%;
              height: 100%;
              margin: 0;
            }
            .van-uploader__preview {
              width: 100%;
              height: 100%;
              margin: 0;
              .van-uploader__preview-image {
                width: 100%;
                height: 100%;
              }
            }
          }
        }
      }
    }
    .upload-box-top {
      height: 120px;
    }
    .upload-box-bottom {
      height: 120px;
    }
  }
}
.date-picker {
  position: fixed;
  z-index: 10;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid #3f99f3;
}
.footer {
  width: 100%;
  display: flex;
  justify-content: center;
}

/deep/ .mu-form-item-label {
  line-height: 22px;
  margin-top: 12px;
}
/deep/.mu-form-item-content {
  align-items: end;
  margin-bottom: 10px;
}
</style>
